import Button from "Components/button";
import Close from "Components/close";
import { TextWidget, hasEmptyRequiredFields } from "Components/optionForm";
import ProgressOverlay from "Components/progressOverlay";
import Scrollbars from "Components/scrollbars";
import { themeVariables } from "Components/theme";
import { Popover } from "Components/withPopover";
import isEmpty from "lodash/isEmpty";
import map from "lodash/map";
import reject from "lodash/reject";
import React, { useCallback, useEffect, useMemo, useRef } from "react";
import { Styled as CommonStyled } from "../../Common";
import { NEW_SCRIPT, requiredFields } from "../constants";
import locale from "./scriptEditorPanel.locale";
import Styled, { SIZES } from "./scriptEditorPanel.styled";
export const progressOverlayStyle = {
    opacity: 0.7,
    backgroundColor: themeVariables["navbar-bg"]
};
export default function ScriptEditorPanel(props) {
    const popoverRef = useRef(null);
    useEffect(() => {
        props.onInitialized && props.onInitialized();
    }, []);
    useEffect(() => {
        var _a;
        if ((_a = popoverRef.current) === null || _a === void 0 ? void 0 : _a.instance) {
            if (props.show)
                popoverRef.current.instance.show();
            else
                popoverRef.current.instance.hide();
        }
    }, [props.show]);
    const position = useMemo(() => ({
        my: "left top",
        at: "right top",
        of: props.targetSelector,
        offset: props.targetOffset || "0 0"
    }), [props.targetSelector, props.targetOffset]);
    const handleHide = useCallback(() => {
        var _a;
        if ((_a = popoverRef.current) === null || _a === void 0 ? void 0 : _a.instance) {
            popoverRef.current.instance.hide();
            props.onClose && props.onClose();
        }
    }, [props.onClose]);
    const handleChangeDraft = useCallback((value, fieldName) => {
        fieldName &&
            props.onSetDraft &&
            props.onSetDraft({
                [fieldName]: value
            });
    }, [props.onSetDraft]);
    const handleCancel = useCallback(() => {
        props.onSetDraft && props.onSetDraft({});
    }, [props.onSetDraft]);
    const handleSave = useCallback(() => {
        !isEmpty(props.draft) && props.onSave && props.onSave(props.draft);
    }, [props.onSave, props.draft]);
    if (!props.draft)
        return null;
    const isEmptyRequiredFields = hasEmptyRequiredFields(props.draft, requiredFields);
    const isNew = props.draft.Id === NEW_SCRIPT.Id;
    return (React.createElement(Popover, { popoverRef: popoverRef, position: position, showEvent: "none", popoverHeight: SIZES.PANEL_HEIGHT, popoverWidth: SIZES.PANEL_WIDTH, popoverClassName: "no-border p-0 no-popover-arrow", popoverContent: React.createElement(ProgressOverlay, { show: props.inProgress, overlayStyle: progressOverlayStyle },
            React.createElement(Styled.Container, null,
                React.createElement("div", { className: "grid-cols-1fr-auto v-center-items pb-0_25" },
                    React.createElement("span", { className: "text-light-on-surface fw-6 font-small" }, isNew ? locale.HEADER_CREATE_SCRIPT : locale.HEADER_EDIT_SCRIPT),
                    React.createElement(Close, { className: "text-light-on-surface mr-0_25", fontSize: 14, onClick: handleHide })),
                React.createElement("div", null,
                    React.createElement(TextWidget, { value: props.draft.Name || "", fieldName: "Name", onChange: handleChangeDraft, label: locale.NAME, labelMode: "floating", height: 44 })),
                React.createElement(Scrollbars, { extraRightSpace: true },
                    React.createElement("div", null, map(props.draft.Methods, item => (React.createElement("div", { key: item.Id, className: "caption-with-actions-panel v-center-items pt-0_25 pb-0_25" },
                        React.createElement("div", { className: "caption-with-actions-panel v-center-items no-gap text-gray-400" },
                            React.createElement("div", { className: "text-overflow-ellipsis font-small" }, `${item.GroupName} / ${item.Name}`)),
                        React.createElement(CommonStyled.TrashIcon, { title: locale.DELETE, onClick: () => {
                                if (!props.draft)
                                    return;
                                const newMethods = reject(props.draft.Methods, ["Id", item.Id]);
                                if (newMethods.length)
                                    handleChangeDraft(newMethods, "Methods");
                                else
                                    handleHide();
                            } })))))),
                React.createElement("div", { className: "d-flex justify-content-flex-end with-gap-8 pt-1" },
                    React.createElement(Button, { className: "btn-h-m p-8-24", text: locale.CANCEL, onClick: handleCancel, disabled: !props.hasChanges }),
                    React.createElement(Button, { text: isNew ? locale.CREATE : locale.SAVE, className: "btn-primary btn-h-m p-8-24", disabled: isEmptyRequiredFields || !props.hasChanges, onClick: handleSave })))) }));
}
